import { render, staticRenderFns } from "./ParentFolders.vue?vue&type=template&id=ffef5d4e&scoped=true&"
import script from "./ParentFolders.vue?vue&type=script&lang=js&"
export * from "./ParentFolders.vue?vue&type=script&lang=js&"
import style0 from "./ParentFolders.vue?vue&type=style&index=0&id=ffef5d4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffef5d4e",
  null
  
)

export default component.exports